<template>
  <div>
    <div
      v-if="
        value != null &&
        value != '' &&
        value.split(';').length != 0 &&
        value.split(';').length > 1
      "
      class="blue mgb10"
      @click="batchRemove"
    >
      批量移除/拖动排序
    </div>
    <el-upload
      ref="upload"
      name="file"
      :action="url"
      :headers="fileHeaders"
      list-type="picture-card"
      :file-list="filesList"
      :on-preview="handlePictureCardPreview"
      :before-remove="beforeRemove"
      :on-remove="handleRemove"
      :before-upload="beforeAvatarUpload"
      :on-success="uploadSectionFile"
      accept=".png, .jpg, .jpeg, .PNG, .JPG, .JPEG, .xlsx,.xls,.xlsm"
      multiple
    >
      <i class="el-icon-plus" />
    </el-upload>

    <div v-if="dialogVisible" class="mask" @click="closeBigImg">
      <div class="bigImg">
        <img :src="dialogImageUrl" />
      </div>
    </div>

    <el-dialog
      :append-to-body="true"
      :title="'批量移除/拖动排序'"
      :close-on-click-modal="false"
      :visible.sync="batchRemoveDF"
      width="50%"
    >
      <div v-if="value != null && value != '' && value.split(';').length != 0">
        <div>
          <el-checkbox
            v-model="checkAllDF"
            :indeterminate="isIndeterminate"
            class="mgb10"
            @change="handleCheckAllChange"
            >{{ $t("action.checkAll") }}</el-checkbox
          >
        </div>
        <cardDragger
          :data="cardList"
          :cardInsideWidth="100"
          :cardInsideHeight="100"
          :cardOutsideWidth="110"
          :cardOutsideHeight="110"
          :colNum="6"
        >
          <template v-slot:header="slotProps">
            <div class="topMenuBox">
              <div class="menuTitle">
                <span style="position: absolute; z-index: 1000; width: 100px">
                  <input
                    v-model="checkeds"
                    type="checkbox"
                    :value="slotProps.item.id"
                    class="float-right"
                    @change="handleCheckedChange"
                  />
                </span>
                <div
                  class="el-card is-always-shadow"
                  style="width: 100px; height: 100px"
                >
                  <el-image
                    style="width: 100px; height: 100px"
                    :src="slotProps.item.name"
                    fit="cover"
                  />
                </div>
              </div>
            </div>
          </template>
          <template v-slot:content="slotProps">
            <div>
              <!-- class="insideData" -->
              <!-- {{ slotProps.item.id }}={{ slotProps.item.positionNum }} -->
            </div>
          </template>
        </cardDragger>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          :loading="batchRemoveDoing"
          size="small"
          @click="batchRemoveSubmit"
          >{{ $t("order.confirm") }}</el-button
        >
        <el-button size="small" @click="batchRemoveDF = false">
          {{ $t("text.close") }}
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Cookies from "@/utils/cookies.js";
import { coreFileserverEndpoint } from "@/settings";
import { cardDragger } from "carddragger";

export default {
  components: {
    cardDragger,
  },
  props: {
    url: {
      type: String,
      default: coreFileserverEndpoint + "/files",
    },
    multiple: Boolean,
    // eslint-disable-next-line vue/require-default-prop
    value: String,
    delete: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      dialogImageUrl: "",
      dialogVisible: false,
      filesList: [], //[{url: name:}]
      fileHeaders: {
        type: "web",
        token: Cookies.getToken(),
      },
      //
      batchRemoveDF: false,
      batchRemoveDoing: false,

      //
      checkeds: [],
      checkAllDF: false,
      isIndeterminate: false,
      //
      cardList: [],
    };
  },

  watch: {
    value: function (val) {
      if (val !== this.serialize(this.filesList)) {
        this.filesList = this.deserialize(val);
      }
      // if (this.filesList.length == 0) {
      //   this.filesList = this.filesList.concat(this.deserialize(val));
      // }
    },
  },
  mounted() {
    this.filesList = this.deserialize(this.value);
  },

  methods: {
    //batchRemove
    batchRemove() {
      const self = this;
      self.cardList = this.value.split(";").map((v, index) => {
        return {
          positionNum: index + 1,
          name: v,
          id: "card" + (index + 1),
        };
      });
      self.batchRemoveDF = true;
    },
    //  全选
    handleCheckAllChange(val) {
      this.checkeds = val ? this.cardList.map((c) => c.id) : [];
    },
    handleCheckedChange(value) {
      const checkedCount = value.length;
      this.checkAllDF = checkedCount === this.cardList.map((c) => c.id).length;
      this.isIndeterminate =
        checkedCount > 0 &&
        checkedCount < this.cardList.map((c) => c.id).length;
    },
    batchRemoveSubmit() {
      const self = this;
      const newImagesArr = this.cardList.sort((a, b) => {
        return a.positionNum - b.positionNum;
      });
      let arr = newImagesArr.filter((item) => !self.checkeds.includes(item.id));
      if (arr.length == 0) {
        self.$emit("input", null);
      } else {
        self.$emit("input", arr.map((a) => a.name).join(";"));
      }
      self.batchRemoveDF = false;
    },
    //====
    beforeAvatarUpload(file) {
      const testmsg = file.name.substring(file.name.lastIndexOf(".") + 1);
      const extension = ["png", "jpg", "jpeg", "PNG", "JPG", "JPEG"];
      if (extension.indexOf(testmsg) === -1) {
        this.$message.error("上传图片只能是 jpg、png、jpeg 格式!");
        return false;
      }
      const isLt10M = file.size / 1024 / 1024 < 10;
      if (!isLt10M) {
        this.$message.error("上传图片大小不能超过 10MB!");
      }
      return isLt10M;
    },
    uploadSectionFile(res, file, fileList) {
      var self = this;
      self.filesList = fileList;
      self.$emit("input", self.serialize(fileList));
    },
    beforeRemove(file, fileList) {
      if (this.delete == true) {
        return true;
      }
      this.$message({
        message: "供应商已接单，不能删除图片",
        type: "warning",
      });
      return false;
    },
    handleRemove(file, fileList) {
      const exists = this.filesList.find((f) => f.url === file.url);
      this.filesList.splice(this.filesList.indexOf(exists), 1);
      this.$emit("input", this.serialize(this.filesList));
    },

    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },

    closeBigImg() {
      this.dialogVisible = false;
    },

    serialize(objs) {
      let resultStr = "";
      let index = 0;
      objs.map((fl) => {
        let url;
        if (!fl.raw) {
          url = fl.url;
        } else if (fl.response) {
          url = fl.response;
        }
        if (index == 0) {
          resultStr = url;
        } else {
          resultStr = resultStr + ";" + url;
        }
        index++;
      });
      return resultStr;
    },

    deserialize(text) {
      if (text == null || text.trim() === "") {
        return [];
      }
      let sequence = 0;
      let resultArr = [];
      text.split(";").map(function (aUrl) {
        if (aUrl) {
          let ups = aUrl.split("/");
          resultArr.push({
            url: aUrl,
            name: ups[ups.length - 1],
            sequence: sequence++,
          });
        }
      });
      return resultArr;
    },

    // 对象数组排序算法
    compare(prop) {
      return function (obj1, obj2) {
        var val1 = obj1[prop];
        var val2 = obj2[prop];
        if (!isNaN(Number(val1)) && !isNaN(Number(val2))) {
          val1 = Number(val1);
          val2 = Number(val2);
        }
        if (val1 < val2) {
          return -1;
        } else if (val1 > val2) {
          return 1;
        } else {
          return 0;
        }
      };
    },
  },
};
</script>
<style>
.mask {
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.5);
  height: 100%;
  width: 100%;
  z-index: 9999;
}

.bigImg {
  position: relative;
  width: auto;
  margin: 0 auto;
  top: 50px;
  height: auto;
  text-align: center;
}

.bigImg img {
  height: auto;
  max-width: 70%;
  max-height: 700px;
}
.el-upload-list--picture-card .el-upload-list__item .el-icon-check,
.el-upload-list--picture-card .el-upload-list__item .el-icon-circle-check {
  top: -25px !important;
  position: relative;
}
</style>
